import { InferType, object, string } from 'yup';

const LogInSchema = object({
  email: string().email('Email is invalid').required('Email is required'),
  password: string()
    .min(8, 'Password must be at least 8 characters')
    .required('Password is required'),
});

export type LogInSchemaType = InferType<typeof LogInSchema>;

export { LogInSchema };
